<template>
    <PremiumFeatureGate required-subscription="premium" :value="value" :inline="inline" @input="$emit('input', $event)">
        <template slot="content">
            <p class="text-body-2 text--secondary mb-4 max-width-lg mx-auto premium-gate-content-intro">
                {{ $translate('companyCompletionPremiumIntro') }}
            </p>
            <ul class="premium-gate-bullets">
                <li>
                    <span class="premium-gate-bullet-icon">
                        <v-icon size="16" color="white">mdi-check</v-icon>
                    </span>
                    <span>{{ $translate('companyCompletionPremiumBullet1') }}</span>
                </li>
                <li>
                    <span class="premium-gate-bullet-icon">
                        <v-icon size="16" color="white">mdi-check</v-icon>
                    </span>
                    <span>{{ $translate('companyCompletionPremiumBullet2') }}</span>
                </li>
                <li>
                    <span class="premium-gate-bullet-icon">
                        <v-icon size="16" color="white">mdi-check</v-icon>
                    </span>
                    <span>{{ $translate('companyCompletionPremiumBullet3') }}</span>
                </li>
            </ul>
        </template>
    </PremiumFeatureGate>
</template>

<script>
import GlobalMixins from "@/mixins/global";
import PremiumFeatureGate from "@/components/common/premium-feature-gate";

export default {
    name: "PremiumFeatureGateCompanyCompletion",
    mixins: [GlobalMixins],
    components: {
        PremiumFeatureGate,
    },
    props: {
        value: {
            type: Boolean,
            default: true,
        },
        inline: {
            type: Boolean,
            default: true,
        },
    },
    i18n: {
        messages: {
            en: {
                companyCompletionPremiumIntro: "Auto-completion of client and supplier details (address, SIREN, VAT, legal structure, etc.) from the directory is a Premium feature. Upgrade to fill forms in one click and reduce errors.",
                companyCompletionPremiumBullet1: "One-click completion of company name, legal name, SIREN, and VAT number.",
                companyCompletionPremiumBullet2: "Automatic filling of billing address (street, city, postal code, country).",
                companyCompletionPremiumBullet3: "Legal details: RCS, NAF code, legal structure, share capital.",
            },
            fr: {
                companyCompletionPremiumIntro: "La complétion automatique des informations clients et fournisseurs (adresse, SIREN, TVA, forme juridique, etc.) à partir du répertoire est une fonctionnalité Premium. Passez en Premium pour remplir les formulaires en un clic et limiter les erreurs.",
                companyCompletionPremiumBullet1: "Complétion en un clic : raison sociale, dénomination, SIREN et numéro de TVA.",
                companyCompletionPremiumBullet2: "Remplissage automatique de l'adresse de facturation (voie, ville, code postal, pays).",
                companyCompletionPremiumBullet3: "Informations juridiques : RCS, code NAF, forme juridique, capital social.",
            },
        },
    },
};
</script>
